module.exports = __webpack_public_path__ + "static/media/back_banner.4676c67f.png";